module.exports = "<Checkbox\n  label=\"Coaches\"\n  value=\"Coaches\"\n  checked\n/>\n"